import styles from './FullscreenContainer.scss';

const FullscreenContainer = ({ children }) => (
    <div className={styles['fullscreen-container']}>{children}</div>
);

export default FullscreenContainer;
